export default "__VITE_ASSET__C4NlivW2__"